import { render, staticRenderFns } from "./InfoBlocks.vue?vue&type=template&id=931ad630&scoped=true&"
import script from "./InfoBlocks.vue?vue&type=script&lang=js&"
export * from "./InfoBlocks.vue?vue&type=script&lang=js&"
import style0 from "./InfoBlocks.vue?vue&type=style&index=0&id=931ad630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931ad630",
  null
  
)

export default component.exports